import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryEntries from '@/pages/home/components/CategoryEntries';
import FeaturedVideos from '@/pages/home/components/FeaturedVideos';
import LatestVideos from '@/pages/home/components/LatestVideos';
import HotRanking from '@/pages/home/components/HotRanking';
import {
  getFeaturedVideos,
  getLatestVideos,
  getHotVideos,
} from '@/utils/videoUtils';

export default function Home() {
  const featured = getFeaturedVideos();
  const latest = getLatestVideos(24);
  const hot = getHotVideos(10);

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />
      <CategoryEntries />
      <FeaturedVideos videos={featured} />
      <LatestVideos videos={latest} />
      <HotRanking videos={hot} />

      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="rounded-lg bg-primary-50 border border-primary-100 px-6 py-8 md:px-10 md:py-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="font-display text-xl md:text-2xl font-bold text-foreground-950">
              关于在线视频
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              在线视频是一家海量视频资源在线观看平台，面向喜爱影视剧、综艺节目及短视频的用户群体。
              我们汇聚电影、电视剧、综艺与短视频内容，提供便捷的分类筛选、关键词搜索与个性化推荐，
              帮助每一位用户快速发现感兴趣的视频，享受流畅的浏览与观看体验。
            </p>
          </div>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors cursor-pointer"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </SiteLayout>
  );
}